import script from "./favoritos.vue?vue&type=script&setup=true&lang=js"
export * from "./favoritos.vue?vue&type=script&setup=true&lang=js"

import "./favoritos.vue?vue&type=style&index=0&id=ee8bc26c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee8bc26c"]])

export default __exports__